import * as React from 'react'
import { styled } from 'next-yak'

import { Icon } from '../Icon'
import { type SpecificIconProps } from '../types'
import { lightweight, standalone, type SymbolProps } from '../../spritesheetUtils'

const ID = 'google-third-party-glyph-icon'

export function GoogleSymbol({ id = ID, ...props }: SymbolProps): React.ReactElement<SymbolProps> {
  return (
    <symbol {...props} id={id} viewBox="0 0 18 18">
      <path d="M9.02719 3.27273C10.9125 3.27273 12.6178 4.24304 13.5952 5.58004L15.9117 3.23991C14.5262 1.43288 11.8597 0 9.02719 0C4.06772 0 0 4.0255 0 9C0 13.9745 4.06772 18 9.02719 18C13.1385 18 16.5969 15.2346 17.6574 11.4545C17.8857 10.669 18 9.85078 18 9V8.18182H9.8429V11.4539H14.1662C13.2689 13.3849 11.2948 14.7273 9.02719 14.7273C5.87863 14.7273 3.26284 12.1581 3.26284 9C3.26284 5.8419 5.87863 3.27273 9.02719 3.27273Z" />
    </symbol>
  )
}

const GoogleStandaloneContent = standalone(GoogleSymbol, ID)

export const Google = styled(function GoogleStandaloneComponent(props: SpecificIconProps) {
  return (
    <Icon {...props} name="social-google">
      <GoogleStandaloneContent />
    </Icon>
  )
})``

export const GoogleLightweight = styled(function GoogleComponent(props: SpecificIconProps) {
  return (
    <Icon {...props} name="social-google">
      {lightweight(ID)}
    </Icon>
  )
})``
